import React from 'react';
import { rankCorrectionEnumList } from '../../types/stat';

interface RankSelectFieldProps {
  value: number;
  onChange: (value: number) => void;
  stopPropagation?: boolean;
  width?: number;
}

function RankSelectField({ value, onChange, stopPropagation = false, width = 48 }: RankSelectFieldProps) {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(Number(event.target.value));
  };

  const handleClick = stopPropagation
    ? (event: React.MouseEvent<HTMLSelectElement>) => {
        event.stopPropagation();
      }
    : undefined;

  return (
    <select
      value={value}
      onChange={handleChange}
      onClick={handleClick}
      style={{ width }}
      className="h-[22px] rounded border border-gray-400 bg-white px-1 text-center text-[0.8rem] shadow-sm focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-200"
    >
      {rankCorrectionEnumList.map((rank) => (
        <option key={rank} value={rank}>
          {rank > 0 ? `+${rank}` : rank}
        </option>
      ))}
    </select>
  );
}

export default RankSelectField;
